import { MutationType } from '@tencent/slide-sdk-pb-model';
import { assert } from 'ts-essentials';
import { BaseMutation } from '../base/base-mutation';
import { Rule } from '../base/mutation-rules';
import { DataType, SHAPE_DATA_TYPES, SLIDE_PAGE_DATA_TYPES } from '../../data';
import { getSingleShapeKeyFrame } from '../../keyframe/get-shape-keyframe';
import { cloneDeep } from '../../utils/clone-deep';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidMutationData, IValidRemoveShapeMutationData } from '../base/valid-mutation-data';

export class RemoveShapeMutation extends BaseMutation<PresentationDataModel, IValidRemoveShapeMutationData> {
    public readonly type: MutationType = MutationType.RemoveShape;

    public apply(presentation: PresentationDataModel) {
        const { models } = presentation.store;
        const { shapeId, parentId } = this.data;

        const parent = models.get(parentId, DataType.GroupShape);
        assert(parent, 'parent should exist');

        parent.store.shapeList.removeById(shapeId);
    }

    /**
     * invert 步骤：
     *
     * 解组至删除图形的位置 - 添加回图形 - 图形移动到正确位置 - 重新组合
     */
    public invert(presentation: PresentationDataModel): IValidMutationData[] {
        const { pageId, shapeId, parentId, index } = this.data;
        const page = presentation.store.models.get(pageId, ...SLIDE_PAGE_DATA_TYPES);
        assert(page, 'page should exist');
        const shape = presentation.store.models.get(shapeId, ...SHAPE_DATA_TYPES);
        assert(shape, 'shape should exist');

        const mutations: IValidMutationData[] = [];
        const context = {
            presentation: presentation.store.data,
            page: page.store.data,
            idFactory: (oldId: string) => oldId,
        };
        mutations.push();

        return getSingleShapeKeyFrame(cloneDeep(shape.store.data), context, parentId, index);
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, shapeId, parentId, index } = this.data;
        return Rule.every(
            Rule.shape.should.existInPage(presentation, shapeId, pageId),
            Rule.shape.is.notTypeOf(presentation, shapeId, DataType.GroupShape),
            Rule.shape.should.matchShapeListInPosition(presentation, parentId, index, [shapeId]),
        );
    }
}
